/**
 * Full sign-out: clear local state and end the Zitadel session. Mirrors the
 * sidebar logout; kept here so pages without a sidebar (awaiting approval)
 * can use it.
 */
export function signOut(): void {
  const hostname = window.location.hostname;
  const parts = hostname.split(".");
  const subdomain = parts.length > 3 || (parts.length === 3 && parts[1] === "business") ? parts[0] : "";

  if (subdomain) {
    localStorage.setItem("logout_return_subdomain", subdomain);
    document.cookie = `logout_subdomain=${subdomain}; path=/; domain=.business.chargingadda.com; max-age=600; secure; SameSite=Lax`;
  }
  const idToken = localStorage.getItem("id_token");
  localStorage.clear();

  const zitadelDomain = "https://idp.cms.chargingadda.com";
  const postLogoutRedirectUri = "https://business.chargingadda.com";
  window.location.href =
    `${zitadelDomain}/oidc/v1/end_session?` +
    `id_token_hint=${idToken}&` +
    `post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri)}`;
}
